<script>
import { mapGetters } from 'vuex';
const validButtonSizes = ['small', 'tiny', 'large'];

export default {
  props: {
    showSeparator: {
      type: Boolean,
      default: true,
    },
    buttonSize: {
      type: String,
      default: undefined,
      validator: value =>
        validButtonSizes.includes(value) || value === undefined,
    },
    gcalendarAuth: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      currentUser: 'getCurrentUser',
    }),
  },
  methods: {
    getGoogleAuthUrl() {
      // Ideally a request to /auth/google_oauth2 should be made
      // Creating the URL manually because the devise-token-auth with
      // omniauth has a standing issue on redirecting the post request
      // https://github.com/lynndylanhurley/devise_token_auth/issues/1466
      const clientId = window.chatwootConfig.googleOAuthClientId;
      const redirectUri = window.chatwootConfig.googleOAuthCallbackUrl;

      const responseType = 'code';
      const baseUrl = this.gcalendarAuth
        ? 'https://accounts.google.com/o/oauth2/auth'
        : 'https://accounts.google.com/o/oauth2/auth/oauthchooseaccount';
      const scope = this.gcalendarAuth
        ? 'profile email https://www.googleapis.com/auth/calendar'
        : 'email profile';

      const urlParams = {
        client_id: clientId,
        redirect_uri: redirectUri,
        scope: scope,
        response_type: responseType,
      };
      if (this.gcalendarAuth) {
        urlParams.included_granted_scopes = 'true';
        urlParams.access_type = 'offline';
        urlParams.state = new URLSearchParams({
          account_id: this.accountId,
          uid: this.currentUser.uid,
          gcal_login: true,
        }).toString();
      }
      // Build the query string
      const queryString = new URLSearchParams(urlParams).toString();

      // Construct the full URL
      return `${baseUrl}?${queryString}`;
    },
  },
};
</script>

<template>
  <div>
    <div v-if="showSeparator" class="separator">OR</div>
    <a :href="getGoogleAuthUrl()">
      <button
        class="button expanded button__google_login"
        :class="{
          // Explicit checking to ensure no other value is used
          large: buttonSize === 'large',
          small: buttonSize === 'small',
          tiny: buttonSize === 'tiny',
        }"
        style="font-size: 16px"
      >
        <!-- <img
          src="assets/images/auth/google.svg"
          alt="Google Logo"
          class="icon"
          style="width: 18px"
        /> -->
        <span class="i-logos-google-icon h-6" />
        <slot>{{ $t('LOGIN.OAUTH.GOOGLE_LOGIN') }}</slot>
      </button>
    </a>
  </div>
</template>

<style lang="scss" scoped>
.separator {
  display: flex;
  align-items: center;
  margin: var(--space-two) var(--space-zero);
  gap: var(--space-one);
  color: var(--s-300);
  font-size: var(--font-size-small);
  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: var(--s-100);
  }
}
.button__google_login {
  background: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-one);
  border: 1px solid var(--s-100);
  color: var(--b-800);
}
</style>
